import { render, staticRenderFns } from "./status-label.vue?vue&type=template&id=2c6d7cf9&scoped=true&"
import script from "./status-label.vue?vue&type=script&lang=js&"
export * from "./status-label.vue?vue&type=script&lang=js&"
import style0 from "./status-label.vue?vue&type=style&index=0&id=2c6d7cf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6d7cf9",
  null
  
)

export default component.exports